import capitalize from '~/helpers/capitalize-helpers';
export default (function (context, inject) {
  inject('capitalize', capitalize);
});